module.exports = __webpack_public_path__ + "img/save-survey-ced.8ae754be.svg";